import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Children } from 'react';
import { useUncontrolled } from 'uncontrollable';
import { Nav } from '../Navs/Nav';
import { NavItem } from '../Navs/NavItem';
import { TabContainer } from './TabContainer';
import { TabContent } from './TabContent';
import { TabPane } from './TabPane';
function getDefaultActiveKey(children) {
    let defaultActiveKey;
    Children.forEach(children, (child)=>{
        if (defaultActiveKey === null || defaultActiveKey === undefined) {
            defaultActiveKey = child.props.eventKey;
        }
    });
    return defaultActiveKey;
}
function renderTab(child) {
    const { title, eventKey, disabled, tabClassName, id, status } = child.props;
    if (title === null || title === undefined) {
        return null;
    }
    return /*#__PURE__*/ _jsx(NavItem, {
        eventKey: eventKey,
        disabled: disabled,
        id: id,
        className: tabClassName,
        status: status,
        children: title
    });
}
export const Tabs = (props)=>{
    const { id, bsStyle = 'tabs', onSelect, transition, animation = true, mountOnEnter = false, unmountOnExit = false, children, activeKey = getDefaultActiveKey(children), ...controlledProps } = useUncontrolled(props, {
        activeKey: 'onSelect'
    });
    return /*#__PURE__*/ _jsxs(TabContainer, {
        id: id,
        activeKey: activeKey,
        onSelect: onSelect,
        transition: animation ? transition : undefined,
        animation: animation,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        children: [
            /*#__PURE__*/ _jsx(Nav, {
                ...controlledProps,
                bsStyle: bsStyle,
                role: "tablist",
                componentClass: "nav",
                children: Children.map(Children.toArray(children).filter((child)=>!!child), renderTab)
            }),
            /*#__PURE__*/ _jsx(TabContent, {
                children: Children.map(Children.toArray(children).filter((child)=>!!child), (child)=>{
                    const childProps = {
                        ...child.props
                    };
                    delete childProps.title;
                    delete childProps.disabled;
                    delete childProps.tabClassName;
                    return /*#__PURE__*/ _jsx(TabPane, {
                        ...childProps
                    });
                })
            })
        ]
    });
};
Tabs.displayName = 'Tabs';
